import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import GoalHeaderAggQuery, {
	type GoalHeaderAggQuery as GoalHeaderAggQueryType,
} from '../components/GoalHeaderRefreshed/agg/__generated__/GoalHeaderAggQuery.graphql';

export const goalViewHeaderAggResource = createRelayResource<GoalHeaderAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';
		const key = routerContext.match.params.id ?? '';

		return {
			query: GoalHeaderAggQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				goalKey: key,
				containerId,
			},
		};
	},
});
